<template>
  <main class="page-main esg-ethical esg-ethical-detail">
    <div class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('ethical.title') }}</h3>
      <!--<div class="page-heading-desc">
        <button type="button" class="btn btn-fill">{{ $t('ethical.download') }}</button>
      </div>-->
    </div>

    <div class="esg-box-content">
      <ethical-list />
    </div>

    <div class="esg-box-image">
      <p>
        <picture>
          <source media="(min-width: 750px)" srcset="~@/static/image/sustainability/pc/ethical.jpg 1x">
          <source media="(min-width: 750px)" srcset="~@/static/image/sustainability/pc/ethical@2x.jpg 2x">
          <source media="(min-width: 750px)" srcset="~@/static/image/sustainability/pc/ethical@3x.jpg 3x">
          <source media="(max-width: 750px)" srcset="~@/static/image/sustainability/m/ethical.jpg 1x">
          <source media="(max-width: 750px)" srcset="~@/static/image/sustainability/m/ethical@2x.jpg 2x">
          <source media="(max-width: 750px)" srcset="~@/static/image/sustainability/m/ethical@3x.jpg 3x">
          <img src="~@/static/image/sustainability/pc/ethical.jpg" alt="">
        </picture>
      </p>
    </div>

    <ol class="conduct-list">
      <li v-for="(item, index) in $t('ethical.list')">
        <div :id="hashTitle($t(item.title))" class="depth-1-title article-anchor" :data-ga="$t(item.title)">
          <strong>{{ $t(item.title) }}</strong>
          <template v-for="content in item.content">
            <html-view :value="$t(content)" tag="p" />
          </template>
        </div>
        <ol class="depth-2">
          <li v-for="(child, key) in item.child" :data-ga="$t(child.title)">
            <strong :id="hashTitle($t(child.title))" class="depth-2-title article-anchor">
              <i>{{ index + 1 }}-{{ key + 1 }}.</i>
              {{ $t(child.title) }}
            </strong>
            <template v-for="childContent in child.content">
              <ol v-if="typeof childContent === 'object'" class="list-inside">
                <template v-for="(childContentList, inside) in childContent">
                  <html-view :value="`<i>${inside + 1}</i>${childContentList}`" tag="li" />
                </template>
              </ol>
              <html-view v-else :value="$t(childContent)" tag="p" />
            </template>
          </li>
        </ol>
      </li>
    </ol>
  </main>
</template>

<script>
import { hashTitle } from '@/util'
import EthicalList from './EthicalList.vue'

export default {
  components: {
    EthicalList
  },
  watch: {
    '$route.hash' (hash) {
      this.goAnchor(hash)
    }
  },
  mounted () {
    const hash = decodeURIComponent(this.$route.hash)
    this.goAnchor(hash)
  },
  methods: {
    hashTitle,
    goAnchor (hash) {
      setTimeout(() => {
        const anchor = document.querySelector(hash)
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'))
        const scrollMarginGap = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--scroll-margin-gap'))
        const scrollMargin = headerHeight + scrollMarginGap
        document.documentElement.scrollTo({
          top: anchor.getBoundingClientRect().top - scrollMargin,
        })
      }, 100)
    }
  }
}
</script>
